import axios from 'axios';
import qs from 'qs';

export const createCourse = (data: any) => axios.post('/api/v1/courses', data);

export const updateCourseById = ({
  courseId,
  data,
}: {
  courseId: string;
  data: any;
}) => axios.put(`/api/v1/courses/${courseId}`, data);

export const copyCourseById = (courseId: string) =>
  axios.post(`/api/v1/courses/${courseId}/copy`);

export const submitCourse = (courseId: string) =>
  axios.post(`/api/v1/courses/${courseId}/submit`);

export const publishCourse = (courseId: string) =>
  axios.post(`/api/v1/courses/${courseId}/publish`);

export const archiveCourse = (courseId: string) =>
  axios.post(`/api/v1/courses/${courseId}/archive`);

export const restoreCourse = (courseId: string) =>
  axios.post(`/api/v1/courses/${courseId}/restore`);

export const removeCourse = (courseId: string) =>
  axios.delete(`/api/v1/courses/${courseId}`);

export const getCourses = (params: Record<string, any>) =>
  axios.get(`/api/v1/courses?${qs.stringify(params)}`);

export const getCourseById = (courseId: string) =>
  axios.get(`/api/v1/courses/${courseId}`);

export const getCoursesStats = () => axios.get('/api/v1/courses/stats');

export const getCourseStats = (courseId: string) =>
  axios.get(`/api/v1/courses/${courseId}/stats`);

export const getCourseStatsByStudent = ({
  courseId,
  studentId,
}: {
  courseId: string;
  studentId: string;
}) => axios.get(`/api/v1/courses/${courseId}/stats/${studentId}`);

export const getCourseModules = (courseId: string) =>
  axios.get(`/api/v1/courses/${courseId}/modules`);

export const createCourseModule = ({
  courseId,
  data,
}: {
  courseId: string;
  data: any;
}) => axios.post(`/api/v1/courses/${courseId}/modules`, data);

export const updateCourseModuleById = ({
  courseId,
  moduleId,
  data,
}: {
  courseId: string;
  moduleId: string;
  data: any;
}) => axios.put(`/api/v1/courses/${courseId}/modules/${moduleId}`, data);

export const removeCourseModuleById = ({
  courseId,
  moduleId,
}: {
  courseId: string;
  moduleId: string;
}) => axios.delete(`/api/v1/courses/${courseId}/modules/${moduleId}`);

export const reorderCourseModules = ({
  courseId,
  data,
}: {
  courseId: string;
  data: any;
}) => axios.post(`/api/v1/courses/${courseId}/modules/reorder`, data);

export const getCourseLessons = (courseId: string) =>
  axios.get(`/api/v1/courses/${courseId}/lessons`);

export const reorderCourseLessons = ({
  courseId,
  data,
}: {
  courseId: string;
  data: any;
}) => axios.post(`/api/v1/courses/${courseId}/lessons/reorder`, data);

export const getCourseLessonById = ({
  courseId,
  lessonId,
}: {
  courseId: string;
  lessonId: string;
}) => axios.get(`/api/v1/courses/${courseId}/lessons/${lessonId}`);

export const linkLessonToCourse = ({
  courseId,
  lessonId,
  moduleId,
  order,
}: {
  courseId: string;
  lessonId: string;
  moduleId?: string;
  order?: number;
}) =>
  axios.post(`/api/v1/courses/${courseId}/lessons/link`, {
    lessonId,
    ...(moduleId ? { moduleId } : {}),
    ...(order != null ? { order } : {}),
  });

export const replaceLessonInCourse = ({
  courseId,
  newLessonId,
  replacedLessonId,
  moduleId,
  order,
}: {
  courseId: string;
  newLessonId: string;
  replacedLessonId: string;
  moduleId?: string;
  order?: number;
}) =>
  axios.post(`/api/v1/courses/${courseId}/lessons/replace`, {
    newLessonId,
    replacedLessonId,
    ...(moduleId ? { moduleId } : {}),
    ...(order != null ? { order } : {}),
  });

export const removeCourseLessonById = ({
  courseId,
  lessonId,
}: {
  courseId: string;
  lessonId: string;
}) => axios.delete(`/api/v1/courses/${courseId}/lessons/${lessonId}`);

export const removeCourseLessons = (courseId: string) =>
  axios.delete(`/api/v1/courses/${courseId}/remove-lessons`);

export const removeCourseModules = (courseId: string) =>
  axios.delete(`/api/v1/courses/${courseId}/remove-modules`);

export const removeCourseStudents = (courseId: string) =>
  axios.delete(`/api/v1/courses/${courseId}/remove-students`);
